import Swal from 'sweetalert2';
import { useContext, useEffect, useState } from 'react';

import OrganizacionContext from 'context/OrganizacionContext';

import {
    getAll,
    create,
    update,
    remove
} from "services/organizationService.js";


export function useOrganizations() {

    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [totalPages, setTotalPages] = useState(0);
    const [totalOrganizations, setTotalOrganizations] = useState(0);

    const {
        organizations,
        setOrganizations,
        loading,
        setLoading,
        message,
        setMessage
    } = useContext(OrganizacionContext);


    /**
     *  Obtener organizaciones
     */
    const getOrganizations = async ({
        page = 1,
        limit = itemsPerPage,
        nit = '',
        kunnr = '',
        razonSocial = ''
    } = {}) => {

        setLoading(true);

        try {

            const response = await getAll({
                page,
                limit,
                nit,
                kunnr,
                razonSocial
            });

            setOrganizations(response.data);
            setTotalPages(response.totalPages || 1);
            setTotalOrganizations(response.total || 0);

        } catch (err) {

            const errorMessage =
                err?.response?.data?.message || "Error obteniendo organizaciones";

            setMessage({ message: errorMessage, status: err?.response?.status });

            Swal.fire('Error', errorMessage, 'error');

        } finally {
            setLoading(false);
        }
    };



    /**
     *  Crear organización
     */
    const createOrganization = async (organization) => {

        try {

            const { message } = await create(organization);

            Swal.fire(
                'Éxito',
                message || 'Organización creada correctamente',
                'success'
            );

            await getOrganizations({ page: 1 });
            setPage(1);

            return true; 

        } catch (err) {

            const errorMessage =
                err?.response?.data?.message || "Error creando organización";

            setMessage({ message: errorMessage, status: err?.response?.status });

            Swal.fire('Error', errorMessage, 'error');

            return false;
        }
    };



    /**
     * Actualizar
     */
    const updateOrganization = async ({ id, organization }) => {

        try {

            const { message } = await update({ id, organization });

            Swal.fire(
                'Éxito',
                message || 'Organización actualizada',
                'success'
            );

            await getOrganizations({ page });
            return true;

        } catch (err) {

            const errorMessage =
                err?.response?.data?.message || "Error actualizando organización";

            setMessage({ message: errorMessage, status: err?.response?.status });

            Swal.fire('Error', errorMessage, 'error');

            return false;

        }
    };


    /**
     *  Eliminar
     */
    const deleteOrganization = async (id) => {

        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'No podrás revertir esto',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {

            const { message } = await remove(id);

            Swal.fire(
                'Eliminado',
                message || 'Organización eliminada',
                'success'
            );

            getOrganizations();

        } catch (err) {

            const errorMessage =
                err?.response?.data?.message || "Error eliminando organización";

            setMessage({ message: errorMessage, status: err?.response?.status });

            Swal.fire('Error', errorMessage, 'error');
        }
    };


    /**
     *  Primera carga
     */
    useEffect(() => {
        getOrganizations({ page, limit: itemsPerPage });
    }, [page, itemsPerPage]);



    return {
        organizations,
        loading,
        message,
        page,
        setPage,
        totalPages,
        itemsPerPage,
        setItemsPerPage,
        getOrganizations,
        createOrganization,
        updateOrganization,
        deleteOrganization,
        totalOrganizations
    };
}
